import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const ADULT_REVIEW_NAMES = ['David Bushman', 'Alecia Williams', 'Pavani Kanduri'];
export function AdultReviews() {
  const reviews = STORM_REVIEWS.filter(r => ADULT_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-598">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-599">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-600">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-601">
            Real Adult Students. Real Reviews.
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-602">
            These are real Storm adult students speaking in their own voice. No
            stock testimonials.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-603">
          {reviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-604" />)}
        </div>
      </div>
    </section>;
}